import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastCustomService {
  isWarning = false;
  isError = false;
  isSuccess = false;

  textWarn = '';
  textError = '';
  textSuccess = '';
  detailWarn = '';
  detailError = '';
  detailSuccess = '';
  currentLang : "TH" | "EN" = 'TH';

  showWarning(text : string , detail: string = '') {
    this.textWarn = text === '' ? ( this.currentLang === 'TH' ? 'แจ้งเตือน!' : 'Warning!') : text;
    this.detailWarn = detail;
    this.isWarning = true;
  }

  showError(text : string , detail: string = '') {
    this.textError = text  === '' ? ( this.currentLang === 'TH' ? 'เกิดข้อผิดพลาด!' : 'Error!') : text;
    this.detailError = detail;
    this.isError = true;
  }

  showSuccess(text : string , detail: string = '') {
    this.textSuccess = text === '' ? ( this.currentLang === 'TH' ? 'สําเร็จ!' : 'Success!') : text;
    this.detailSuccess = detail;
    this.isSuccess = true;
  }
}
